import request from '@/utils/request';

/**
 *   获取应用类型列表
 * @method getApptypesist
 * @return { request } axsio请求封装
 */
export function getApptypesList(params) {
  return request({
    url: `/apptypes/page-list`,
    method: 'get',
    params: params
  });
}

/**
 *   获取应用类型树
 * @method getApptypesTree
 * @return { request } axsio请求封装
 */
export function getApptypesTree() {
  return request({
    url: `/apptypes/appTypeTree`,
    method: 'get'
  });
}

/**
 *   新增应用类型
 * @method addApplicationType
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function addApplicationType(form) {
  return request({
    url: `/apptypes/`,
    method: 'post',
    data: form
  });
}

/**
 *   编辑应用类型
 * @method editApplicationType
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function editApplicationType(form) {
  return request({
    url: `/apptypes/${form.id}`,
    method: 'post',
    data: form
  });
}

/**
 *   批量修改应用类型状态
 * @method editApplicationType
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function editApplicationStatus(form) {
  return request({
    url: `/apptypes/batch-status`,
    method: 'post',
    data: form
  });
}

/**
 *   应用类型上移下移
 * @method moveApplication
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function moveApplication(form) {
  return request({
    url: `/apptypes/modifySeq`,
    method: 'post',
    data: form
  });
}
